import { render, staticRenderFns } from "./Colofon.vue?vue&type=template&id=468aeab7&"
import script from "./Colofon.vue?vue&type=script&lang=js&"
export * from "./Colofon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Colofon.vue"
export default component.exports